<template>
    <div class="mt-1">
      <ValidationProvider v-if="condition"  :vid="validation_label" :name="validation_label" :rules="getRules" v-slot="{ errors }">
        <div class="upload-btn-wrapper">
          <button v-bind:class="{ btn_success: file || !errors[0], btn_danger: !file  && !!errors[0]  }" class="">Upload a file</button>
          <input  @change="fileUploader($event)" type="file" name="myfile" />
        </div>
        <vs-chip @click="onClickFileRemove" closable v-if="(condition && file) || !!errors[0]" transparent :color="file || !errors[0] ? 'dark' : 'danger'"  class="mt-4">
          <a target="_blank" style="text-decoration: none" class="text-dark" :href="file" >{{__nameSplitter(file)}}</a>
        </vs-chip>
        <span style="display: none">{{file}}</span>
      </ValidationProvider>
    </div>
</template>

<script>
  const SupplierRepository = RepositoryFactory.get('supplier');
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  export default {
      name: "file-uploader",
      props: {
        file: String,
        condition: null,
        required: true
      },
    data() {
      return {
        validation_label: (Math.floor(Math.random() * 999999) + 1) + ' '
      }
    },
    computed: {
        getRules: function () {
            return this.file ? '' : 'file_required'
        }
    },
      methods: {
        onClickFileRemove() {
          this.file = ''
          this.$emit('onClickFileRemove')
        },
        async fileUploader(event){
          this.$vs.loading();
          try {
            const file = await event.target.files[0]
            let formData = new FormData();
            formData.append('file', file);
            const file_name =  (await SupplierRepository.uploadFile(formData)).data.data.file
            this.file= file_name
            this.$emit('onSetFileName', file_name)
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },
      }
    }
</script>

<style scoped>

</style>
